import PropTypes from 'prop-types';
import Header, {headerItemsLabels} from '../../Common/Header/header';
import useLabels from 'infrastructure/js/hooks/useLabels';
import SpoolingGrid from './SpoolingGrid/spoolingGrid';
import {PL_DialogWrapper} from 'infrastructure/js/components/Dialog/dialog';
import CreateSpoolFromCassettesDialog from '../../Dialogs/CreateSpoolFromCassettesDialog/createSpoolFromCassettesDialog';

require('./spoolingView.scss');


const hasSameMaterial = (items) => {
  if (items?.length === 0) return false;

  const { material: { id } } = items[0];

  return items.every(
    item => item.material.id === id
  );
}

export default function SpoolingView(props) {

  const labels = useLabels('mat.locationpage.view.spooling.');

  const onRefreshAll = () => {
    props.actions?.locationPageActions?.reload?.();
  };

  const getHeaderItems = () => {

    let {actions, sSelectedRowsData} = props;

    let items = {
      title: labels.get('header.title'),
      buttons: [
        {
          id: 'clearFilters',
          label: '',
          icon: 'pl pl-filter-clear',
          action: actions.spoolingViewActions.clearFilters,
          tooltip: headerItemsLabels.CLEAR_FILTERS,
        },
        {
          id: 'refreshAll',
          label: '',
          icon: 'pl pl-refresh',
          action: onRefreshAll,
          tooltip: headerItemsLabels.REFRESH_ALL,
        },
        {
          id: 'createCassettes',
          label: headerItemsLabels.CREATE_SPOOL_FROM_CASSETTES,
          icon: 'pl pl-header-icon-spool',
          disabled: (!hasSameMaterial(sSelectedRowsData?.toJS())),
          action: actions.createSpoolFromCassettesActions.show,
          actionData: sSelectedRowsData,
        },
      ]
    }
    return items;
  }

  const headerItems = getHeaderItems();

  return (
    <div className="spooling-view">
      <Header  {...headerItems}/>

      <SpoolingGrid actions={{...props.actions.spoolingGridActions, ...props.actions.fetchEntitiesActions}}/>

      <PL_DialogWrapper dialogComponent={CreateSpoolFromCassettesDialog}
                        show={props.sCreateSpoolFromCassettesData.get('show')}
                        sData={props.sCreateSpoolFromCassettesData}
                        actions={props.actions.createSpoolFromCassettesActions}
                        fetchEntitiesActions={props.actions.fetchEntitiesActions}
                        reloadParentComponent={onRefreshAll}
      />

    </div>
  )

}

SpoolingView.propTypes = {
  actions: PropTypes.object.isRequired,
  sSelectedRowsData: PropTypes.object.isRequired,
  sCreateSpoolFromCassettesData: PropTypes.object.isRequired,
};
